import * as React from "react"
import { Link } from "react-router-dom"
import Stack from 'react-bootstrap/Stack';
import {NavigationBar, Layout} from "./layout"
import * as styles from "./index.module.css"
import ExpandableTable from "./expandableTable";
import Table from "react-bootstrap/Table";

import { Typography } from "@mui/material";
const Contribution = () => {
  let projectsAndDonationMethods=  <Table style={{tableLayout: "fixed"}}><tbody><tr>
  <td colSpan={5} rowSpan={3}>捐款項目:<br/><br/>

  <ul>
    <li>常住</li>
    <li>現前僧</li>
    <li>國際 / 國內弘法</li>
    <li>印經</li>
    <li>大舍利塔工程：舍利展，建舍利塔</li>
    <li>構建道場設施：場地，佛像，法器</li>
    <li>放生</li>
    <li>七七法會</li>
    <li>孝心青少年活動</li>

  </ul>
  <br/>
  若無指定捐款項目，捐款將劃歸常住。
  <br/>
        </td>
        <td>海淘 / PayPal<br/></td>
  <td colSpan={2}><form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
  <input type="hidden" name="cmd" value="_s-xclick" />
  <input type="hidden" name="hosted_button_id" value="3X3DSBFAURTV2" />
  <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!" />
  <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
  </form></td>
  </tr>
  <tr>
  <td>電彙 /<br/>Wiring/<br/>Bank Transfer</td>
  <td colSpan={2}>請聯係我們索取電彙指南。</td>
  </tr>
  <tr>
  <td>支票<br/></td>
  <td colSpan={2}>收款人：BLI<br/>
  Payable to BLI<br/><br/>
  收件地址: <br/>
  7509 Mooney Drive<br/>
  ​Rosemead, CA 91770</td>
  </tr>
  </tbody></Table>

if((typeof window !== 'undefined') && window.screen.width< 667) {
  projectsAndDonationMethods=  <>捐款項目:<br/><br/>

  <ul>
    <li>常住</li>
    <li>現前僧</li>
    <li>國際 / 國內弘法</li>
    <li>印經</li>
    <li>大舍利塔工程：舍利展，建舍利塔</li>
    <li>構建道場設施：場地，佛像，法器</li>
    <li>放生</li>
    <li>七七法會</li>
    <li>孝心青少年活動</li>

  </ul>
  <br/>
  若無指定捐款項目，捐款將劃歸常住。
  <br/><br/>
  <Table><tbody><tr>
  <td>海淘 / PayPal<br/></td>
  <td colSpan={2}><form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
  <input type="hidden" name="cmd" value="_s-xclick" />
  <input type="hidden" name="hosted_button_id" value="3X3DSBFAURTV2" />
  <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" alt="PayPal - The safer, easier way to pay online!" />
  <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
  </form></td>
  </tr>
  <tr>
  <td>電彙 /<br/>Wiring/<br/>Bank Transfer</td>
  <td colSpan={2}>請聯係我們索取電彙指南。</td>
  </tr>
  <tr>
  <td>支票<br/></td>
  <td colSpan={2}>收款人：BLI<br/>
  Payable to BLI<br/><br/>
  收件地址: <br/>
  7509 Mooney Drive<br/>
  ​Rosemead, CA 91770</td>
  </tr>
  </tbody></Table>

  </>;

}

  return (
  <><NavigationBar/>
  {/* Hero Image */}
<div style={{ display: "grid" }}>
  <img
    style={{
      gridArea: "1/1",
      // maxHeight: 600,
    }}
    layout="fullWidth"
    aspectRatio={3 / 1}
    alt=""
    src="/donationBanner.png"
  quality="40"
    formats={["auto", "webp", "avif"]}/>
  <div
    style={{
      gridArea: "1/1",
      position: "relative",
      placeItems: "center",
      display: "grid",
    }}
  >
  </div>
</div>
{/* Main Content */}
  <Layout>
  <Typography variant="h3"><strong>捐款布施</strong></Typography><br/>
  <Typography variant="body1">
{projectsAndDonationMethods}
<br/><br/>
</Typography>
<Typography variant="h3"><strong>義工布施</strong></Typography><br/>
<Typography variant="body1">若您希望到道場當義工請<a href="mailto:xq2@chanpureland.org">聯係我們</a>。<br/><br/><br/>
BLI是一個符合美國國稅局稅法條款501(c)(3)項的慈善組織。</Typography>
  </Layout>
  </>
)
  }

export default Contribution;
